import { customerHierarchySlice } from "./customerHierarchySlice";
import * as defaultActions from "../../../../../redux/_common";

const { actions } = customerHierarchySlice;

export const QPARAMS_CHANGED = "customerHierarchy/QParamsChanged";

export const setValidationErrors = actions.setValidationErrors;
const moduleUrl = '/api/appmasterdata/customer/hierarchies'

export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );

export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);
